export const destinations = {
    title: "Kierunki",
    sortName: "Nazwa",
    noResults: "Brak wyników",
    tryDifferentSearch: "Spróbuj innego wyszukiwania"
};
